module.exports = __webpack_public_path__ + "img/japan-digestive-diseases-female.33b661d5.png";